import {compose} from 'redux';
import {injectIntl} from 'react-intl';

import {createElement, PropTypes} from 'rlink-react';

import {INTL_MESSAGES} from '../messages/constants';

function MonthSelector ({selectedMonth, onChange, intl}) {
  return (
    <select
      value={selectedMonth}
      onChange={ev => onChange(Number(ev.target.value))}>
      <optgroup label={intl.formatMessage(INTL_MESSAGES.SELECT_MONTH)}>
        <option value={0}>
          {intl.formatMessage(INTL_MESSAGES.JANUARY)}
        </option>
        <option value={1}>
          {intl.formatMessage(INTL_MESSAGES.FEBRUARY)}
        </option>
        <option value={2}>
          {intl.formatMessage(INTL_MESSAGES.MARCH)}
        </option>
        <option value={3}>
          {intl.formatMessage(INTL_MESSAGES.APRIL)}
        </option>
        <option value={4}>
          {intl.formatMessage(INTL_MESSAGES.MAY)}
        </option>
        <option value={5}>
          {intl.formatMessage(INTL_MESSAGES.JUNE)}
        </option>
        <option value={6}>
          {intl.formatMessage(INTL_MESSAGES.JULY)}
        </option>
        <option value={7}>
          {intl.formatMessage(INTL_MESSAGES.AUGUST)}
        </option>
        <option value={8}>
          {intl.formatMessage(INTL_MESSAGES.SEPTEMBER)}
        </option>
        <option value={9}>
          {intl.formatMessage(INTL_MESSAGES.OCTOBER)}
        </option>
        <option value={10}>
          {intl.formatMessage(INTL_MESSAGES.NOVEMBER)}
        </option>
        <option value={11}>
          {intl.formatMessage(INTL_MESSAGES.DECEMBER)}
        </option>
      </optgroup>
    </select>
  );
}

MonthSelector.propTypes = {
  selectedMonth: PropTypes.number,
  onChange: PropTypes.func,
  intl: PropTypes.object,
};

export default compose(
  injectIntl
)(MonthSelector);



// WEBPACK FOOTER //
// ./lib/rlink-agegate/components/MonthSelector.jsx